import { useMemo } from 'react'

import { StructureExportDto } from '@/endpoints/models'
import { useAppContext } from '@/hooks'

const TYPE_LABEL_KEYS: Partial<Record<StructureExportDto.TypeEnum, string>> = {
	[StructureExportDto.TypeEnum.ROOT]: 'ROOT',
	[StructureExportDto.TypeEnum.SYSTEM]: 'SYSTEM',
	[StructureExportDto.TypeEnum.FOLDER]: 'FOLDER',
	[StructureExportDto.TypeEnum.FOLDER_WORKFLOW]: 'FOLDER_WORKFLOW',
	[StructureExportDto.TypeEnum.TABLE]: 'TABLE',
	[StructureExportDto.TypeEnum.VIEW]: 'VIEW',
	[StructureExportDto.TypeEnum.MAPPING]: 'MAPPING',
	[StructureExportDto.TypeEnum.MAPPING_READ]: 'MAPPING_READ',
	[StructureExportDto.TypeEnum.MAPPING_WRITE]: 'MAPPING_WRITE',
	[StructureExportDto.TypeEnum.MAPPING_DEFAULT]: 'MAPPING_DEFAULT',
	[StructureExportDto.TypeEnum.WORKFLOW]: 'WORKFLOW',
	[StructureExportDto.TypeEnum.API_NODE]: 'API_NODE',
	[StructureExportDto.TypeEnum.API_COLLECTION]: 'API_COLLECTION',
	[StructureExportDto.TypeEnum.QUEUE]: 'QUEUE',
	[StructureExportDto.TypeEnum.CONSTANT_DOMAIN]: 'CONSTANT_DOMAIN',
	[StructureExportDto.TypeEnum.TABLE_COLUMN]: 'COLUMN',
}

export const useStructureExportTypeLabel = () => {
	const { t } = useAppContext()

	return useMemo(
		() => (type?: StructureExportDto.TypeEnum) => {
			if (!type) return t('ROOT')
			const key = TYPE_LABEL_KEYS[type]
			return key ? t(key) : type
		},
		[t],
	)
}
